import { FormControl, RadioGroup } from '@mui/material'

import { IEvaluacion } from '../constants';
import FControlLabel from '../../shared/Forms/FControlLabel'


interface Props {
  dataEvaluacion: IEvaluacion;
  handleChange(type: string, value: string | number): void;
  sexo: boolean;
}

const ActividadFisica = ({ dataEvaluacion, handleChange, sexo } : Props) => {
  return (
    <>
      <div className="text-center">
        <br />
        <h5 className='font-bold mb-2'>¿Cuál es tu actividad física actualmente?</h5>
        <p className="text-slate-500">Seleccione que tan frecuentemente realiza actividad física</p>
      </div>
      <div className="row">
        <div className="col-12">
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="2"
              name="radio-buttons-group"
              value={ dataEvaluacion.tipoActividad }
              onChange={(e) => {
                handleChange("tipoActividad", e.target.value)
              }}
              style={{ textAlign: 'left', marginBottom: '1rem' }}
            >
              <FControlLabel
                value="1"
                size='1.15rem'
                label={sexo === true ? 'Sedentario' : 'Sendetaria'}
              />
              <div className="select-detail-fase">
                Paso la mayor parte del tiempo sentado. <br /> No realizo ningún tipo de
                actividad física.
              </div>

              <br />
              <FControlLabel
                value="2"
                size='1.15rem'
                label={
                  sexo === true
                    ? 'Ligeramente activo'
                    : 'Ligeramente activa'
                }
              />
              <div className="select-detail-fase">
                Realizo actividad física de 1 a 3 veces por semana,<br /> ya sea
                entrenar en casa o gym, trotar, montar bicicleta, jugar fútbol,
                etc.
              </div>
              <br />
              <FControlLabel
                value="3"
                size='1.15rem'
                label={ sexo === true ? 'Activo' : 'Activa'}
              />
              <div className="select-detail-fase">
                Realizo actividad física de 3 a 6 veces por semana, <br /> ya sea
                entrenar en casa o gym, trotar, montar bicicleta, jugar fútbol,
                etc.
              </div>
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </>
  )
}

export default ActividadFisica;